import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verificar se há um usuário logado no localStorage
    const savedUser = localStorage.getItem('avenida_admin');
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (error) {
        localStorage.removeItem('avenida_admin');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    
    try {
      const response = await api.post('/auth/login', { email, password });

      if (response.data?.success && response.data.user) {
        const userData = {
          ...response.data.user,
          token: response.data.token,
          loginTime: new Date().toISOString()
        };

        setUser(userData);
        localStorage.setItem('avenida_admin', JSON.stringify(userData));
        setLoading(false);
        return { success: true, user: userData };
      }

      setLoading(false);
      return {
        success: false,
        error: response.data?.error || 'Credenciais inválidas'
      };
    } catch (error) {
      setLoading(false);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erro ao fazer login' 
      };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('avenida_admin');
  };

  const updateUser = (userData) => {
    const updatedUser = { ...user, ...userData };
    setUser(updatedUser);
    localStorage.setItem('avenida_admin', JSON.stringify(updatedUser));
  };

  const value = {
    user,
    login,
    logout,
    updateUser,
    loading,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
